/*设置cookie*/
const _expire = 60 * 60 * 24 * 30
export function setCookie(c_name, value) {
	var date = new Date()
	date.setSeconds(date.getSeconds() + _expire)
	document.cookie = c_name + "=" + encodeURIComponent(value) + "; expires=" + date.toGMTString()
}
/*获取cookie*/
export function getCookie(c_name) {
	if (document.cookie.length > 0) {
		let c_start = document.cookie.indexOf(c_name + "=")
		if (c_start != -1) {
			c_start = c_start + c_name.length + 1
			let c_end = document.cookie.indexOf(";", c_start)
			if (c_end == -1) c_end = document.cookie.length
			const raw = document.cookie.substring(c_start, c_end)
			try {
				return decodeURIComponent(raw)
			} catch (e) {
				return raw // 或 return ""
			}
		}
	}
	return ""
}
/*删除cookie*/
export function delCookie(c_name) {
	setCookie(c_name, "")
}


export function clearCookie() {
	var date = new Date();
	date.setTime(date.getTime() - 1);
	var keys = document.cookie.match(/[^ =;]+(?==)/g);
	if (keys) {
		var exp = new Date();
		for (var i = 0; i < keys.length; i++) {
			exp.setTime(exp.getTime() - 1);
			var cval = getCookie(keys[i]);
			if (cval != null)
				document.cookie = keys[i] + "=" + cval + ";expires=" + exp.toGMTString();
		}
	}
}
